import React from "react";
import "./blog.css";
import { Article } from "../../components";
import { motion, useInView } from "framer-motion";
import {
  blog01,
  blog02,
  blog03,
  blog04,
  blog05,
} from "../../components/article/imports";

const staggered = {
  hidden: { rotate: 90 },
  show: {
    rotate: 0,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.3,
    },
  },
};

const Blog = () => {
  const ref = React.useRef(null);

  const isInView = useInView(ref, { once: false });

  return (
    <div className="gpt3__blog section__padding" id="blog">
      <div className="gpt3__blog-heading">
        <h1 className="gradient__text">
          A lot is happening, <br /> We are blogging about it.
        </h1>
      </div>
      <motion.div
        className="gpt3__blog-container"
        ref={ref}
        style={{
          transform: isInView ? "none" : "translateX(-10px)",
          opacity: isInView ? 1 : 0,
          transition: "all .6s ease .6s",
        }}
      >
        <div className="gpt3__blog-container_groupA">
          <Article
            imgUrl={blog01}
            date="Sep 26, 2021"
            text="GPT-3 and Open  AI is the future. Let us exlore how it is?"
          />
        </div>
        <motion.div
          className="gpt3__blog-container_groupB"
          variants={isInView ? staggered : ""}
          initial="hidden"
          animate="show"
        >
          <Article
            imgUrl={blog02}
            date="Sep 26, 2021"
            text="GPT-3 and Open  AI is the future. Let us exlore how it is?"
          />
          <Article
            imgUrl={blog03}
            date="Sep 26, 2021"
            text="GPT-3 and Open  AI is the future. Let us exlore how it is?"
          />
          <Article
            imgUrl={blog04}
            date="Sep 26, 2021"
            text="GPT-3 and Open  AI is the future. Let us exlore how it is?"
          />
          <Article
            imgUrl={blog05}
            date="Sep 26, 2021"
            text="GPT-3 and Open  AI is the future. Let us exlore how it is?"
          />
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Blog;
